import React from 'react';
import PageTitle from '../../layouts/PageTitle';
import '../../../scss/pages/_report-list.scss'


const DayReport = () => {
    return (
        <div className='dayReport'>

            <PageTitle
                title="Reports"
                subtitle="End of day report"
            />

            <div className='day_select'>
                <select className='border-0' name="week" id="week" style={{ width: '60px' }}>
                    <option value="" selected>Today</option>
                    <option value="">Yesterday</option>
                    <option value="">This week</option>
                    <option value="">Last week</option>
                    <option value="">Custom</option>
                </select>
            </div>

            <div className='card-header day_report_details mt-4' style={{ paddingRight:'0px' }}>
                <div className='d-flex justify-content-end me-4'>
                   <i className="mdi mdi-download mdi-24px"></i>
                    <i className="mdi mdi-send ml-3"></i>
                </div>

                <h4>Outlet A</h4>

                <div className="row w-100 mt-3">
                    <div className="col-md-6 col-lg-6">
                        <span>Cash</span>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul className='me-2'>
                            <li>  <b>SGD 80.90</b></li>
                            <li><small>5 orders</small></li>
                        </ul>
                    </div>
                </div>
                <div className="row w-100 mt-3">
                    <div className="col-md-6 col-lg-6">
                        <span>Online</span>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul>
                            <li><b>SGD 105.00</b></li>
                            <li><small>5 orders</small></li>
                        </ul>
                    </div>
                </div>
                <hr />
                <div className="row w-100">
                    <div className="col-md-6 col-lg-6">
                        <span className='fw-bold'>Total</span>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul>
                            <li><b>SGD 185.90</b></li>
                            <li><small>10 orders</small></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="row mt-5">
                <span className=''>Disclaimer. Please note that the reports present raw and unconditioned order data. Revenues include onlyfood values(excluding discounts, delivery fees, etc).Final settlements can be from the invoice</span>
             </div>
        </div>
    );
};

export default DayReport;